/* import external modules */
import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Row, Col } from 'styled-bootstrap-grid'
import { useSelector, useDispatch } from 'react-redux'

/* import internal modules */
import WithoutCampaigns from '../../WithoutCampaigns'
import P from '../../Common/P'
import CampaignsList from '../CampaignsList'
import CardInfo from '../../Common/CardInfo'
import NewCard from '../../Common/Card'
import useCustomerRoutes from '../../../constants/routes'
import { setTabProducts, setWereCookiesAccepted } from '../../../redux/actions/campaigns/campaigns'

/** @description This is a container functional component of CampaignsAndMaterials
 **  @version 1.0.0
 *  @since 02/12/2020
 *  @author Yadurani López Rivera <yadlop.ext@eltiempo.com>
 *
 *  @function
 *  @name CampaignsAndMaterials
 *  @param {array} campaignsList List of purchased campaigns
 *  @param {bool} loaded If request api was finally
 *  @returns {Component} Returns the container component of the Campaigns And Materials
 **/

const CampaignsAndMaterials = ({ campaignsList, loaded, messages }) => {

  const selectedTab = useSelector((state) => state.campaigns.selectedTab);
  const [url, setUrl] = useState('')
  const dispatch = useDispatch()
  const routes = useCustomerRoutes(url)

  const ADS = campaignsList.filter((item) => { return item.productType === null || item.productType === 1 })
  const CONDOLENCE = campaignsList.filter((item) => { return item.productType === 2 })
  const redirectBuy = () => window.open(routes.customersStartCondolencePage)
  useEffect(() => {
    const location = window.location.origin
    setUrl(location)
  }, [])

  if(!CONDOLENCE.length > 0 || !ADS.length > 0){
    
    if(ADS.length > 0){
      dispatch(setTabProducts("ET ADS"))
    }

    if(CONDOLENCE.length > 0){
      dispatch(setTabProducts("ET CONDOLENCIAS"))
    }
  }

  return campaignsList && campaignsList.length > 0 ? (
    <>
      <Row>
        <Col col xxl="12" xl="12" lg="12" md="12" sm="12" xs="12">
          <P
            color={(selectedTab === "ET CONDOLENCIAS" ? CONDOLENCE.length === 0 ? "#323334" : "#4f5356" : "#252627")}
            font={selectedTab === "ET CONDOLENCIAS" ? CONDOLENCE.length === 0 ? "800 32px/24px'Open Sans'" : "30px/26px'DMSans-Medium'" : "30px/26px'DMSans-Medium'"}
            fontSm="20px/28px'DMSans-Medium'"
            p="50px 0 50px 0"
            pSm="5px 0 45px 0">
            {
              selectedTab === "ET ADS" && ("Mis campañas y materiales")
            }
            {CONDOLENCE.length === 0 ? <>
              {
                selectedTab === "ET CONDOLENCIAS" && ("Bienvenido")
              }
            </> : <>
              {
                selectedTab === "ET CONDOLENCIAS" && ("Mis mensajes de condolencias")
              }
            </>
            }
            {/* {
              selectedTab === "ET CONDOLENCIAS" && ("Mis mensajes de condolencias")
            } */}
          </P>
        </Col>
      </Row>
      <Row>
        <Col col xxl="12" xl="12" lg="12" md="12" sm="12" xs="12">
          {
            selectedTab === "ET ADS" && (<CampaignsList campaignsList={ADS} />)
          }

          {CONDOLENCE.length === 0 && selectedTab === "ET CONDOLENCIAS" ? <div>
            <P color="#444444"
              font="20px/28px'Open Sans'"
              fontSm="16x/24px'Open Sans'"
            > Al adquirir algunos de nuestros productos podrás administrar tus servicios de Condolencias EL TIEMPO</P>
            <div style={{ marginTop: "30px", alignItems: "center", display: "flex", justifyContent: "center", }}>
              <NewCard titleText={"¡Deja un mensaje de aliento!"}
                descriptionText={"Publica tu condolencia y lleva tu mensaje a quienes lo necesitan."}
                textButton={"Crea tu mensaje"}
                onClick={redirectBuy}
                image={"/images/newspaper.svg"}

              />
            </div>
          </div> : <>
            {
              selectedTab === "ET CONDOLENCIAS" && (<>
                <CampaignsList campaignsList={CONDOLENCE} messageList={messages} />
              </>)
            }
          </>
          }


        </Col>
      </Row>
    </>
  ) : loaded ? (
   <WithoutCampaigns />
  ) : null
}

CampaignsAndMaterials.propTypes = {
  campaignsList: PropTypes.array,
  loaded: PropTypes.bool,
}

export default CampaignsAndMaterials
